








































































































































































































































import { AxiosError, AxiosResponse } from 'axios';
import _ from 'lodash';
import VueJsonPretty from 'vue-json-pretty';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import ActionBar from '@/components/action-bar/action-bar.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import WizardProgress from '@/modules/dap/components/wizard-progress/wizard-progress.vue';

import { MarketLevelType } from '@/modules/dap/enums';
import { IMarketLevelLimit, IProject, ISubProject } from '@/modules/dap/interfaces';
import { Project, SubProject } from '@/modules/dap/models';
import { httpService, numeralService } from '@/services';

import { CONFIG } from '@/config';
import { DAP_ROUTES } from '@/modules/dap/router';

@Component({
  components: {
    ActionBar,
    PageLoader,
    WizardProgress,
    VueJsonPretty
  }
})
export default class DapWizardMethodologySimplePage extends Vue {
  @Prop() projectId: number;
  @Prop() dapId: number;
  @Prop() wizardStep: number;

  public DAP_ROUTES = DAP_ROUTES;

  public currentTab: number = 0;
  public productsDataSource: Array<any> = [];
  public segmentsDataSource: Array<any> = [];
  public project: IProject = new Project();
  public subProject: ISubProject = new SubProject();

  public marketLevelIndicator: Array<any> = [{
    text: 'Acima do limite superior de',
    role: 'roleLimitSuperior',
    percent: 'percentIncreaseLimitSuperior',
    limit: 'marketShareSuperior',
    label: 'D',
    color: 'red'
  }, {
    text: 'Entre o limite superior e o MS médio de',
    role: 'roleLimitMedium',
    percent: 'percentIncreaseLimitMedium',
    limit: 'marketShareMedium',
    label: 'C',
    color: 'purple'
  }, {
    text: 'Entre o limite inferior e o MS médio de',
    role: 'roleLimitMediumInferior',
    percent: 'percentIncreaseLimitMediumInferior',
    limit: 'marketShareMedium',
    label: 'B',
    color: 'olive'
  }, {
    text: 'Abaixo do limite inferior de',
    role: 'roleLimitInferior',
    percent: 'percentIncreaseLimitInferior',
    limit: 'marketShareInferior',
    label: 'A',
    color: 'blue'
  }];

  public marketShareOperationDataSource () {
    return [{
      text: 'atingir o limite superior',
      value: 1
    }, {
      text: 'atingir o limite médio',
      value: 2
    }, {
      text: 'atingir o limite inferior',
      value: 3
    }, {
      text: 'manter',
      value: 4
    }, {
      text: 'aumentar vendas',
      value: 5
    }];
  }

  public get isTotalInfluenceLevelValid () {
    return this.isInfluenceLevelValid;
  }

  public get isInfluenceLevelValid () {
    return _.sumBy(this.productsDataSource, (d: any) => d.totalInfluence) !== 1;
  }

  public get currentMarketLevelDataSource (): Array<IMarketLevelLimit> {
    return _(this.subProject.subProjectLimits)
      .value();
  }

  public get productsDataSourceGroup () {
    return _(this.productsDataSource).orderBy((p: any) => p.text).chunk(6).value();
  }

  public updateInputNumber (event: any, data: any, property: string) {
    data[property] = (Math.round(numeralService.parseToNumber(event.target.value) * 100) / 100) || 0 as any;
  }

  public getMarketShareInfluence (id: number, type: number) {
    return {
      marketLevelName: MarketLevelType[type] as any,
      idMarketLevelType: type,
      idSubProjectLimit: id,
      idMarketShareReference: id,
      roleLimitSuperior: 4,
      percentIncreaseLimitSuperior: 0,
      roleLimitMedium: 4,
      percentIncreaseLimitMedium: 0,
      roleLimitMediumInferior: 4,
      percentIncreaseLimitMediumInferior: 0,
      roleLimitInferior: 4,
      percentIncreaseLimitInferior: 0
    };
  }

  @Emit('submit')
  public createDap () {
    const marketShareInfluence = _.map(this.subProject.subProjectLimits, (m: IMarketLevelLimit) => m.marketShareInfluence);
    const segmentInfluence = _.map(this.currentMarketLevelDataSource, (ml: IMarketLevelLimit) => ({
      // TODO: Avaliar por que o id está sendo setado errado.
      idSubProjectLimit: ml.id,
      idSegmentGroup: this.subProject.familySegmentInfluence,
      familyValues: _.map(this.productsDataSource, (p: any) => ({
        idFamilyGroup: p.value,
        percentValue: p.totalInfluence
      }))
    }));

    const req = [
      httpService.http.post(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/subProject/${this.dapId}/marketShareInfluence`, marketShareInfluence),
      httpService.http.post(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/subProject/${this.dapId}/segmentInfluence`, segmentInfluence)
    ];

    Promise.all(req)
      .then((res: AxiosResponse[]) => {
        this.$router.push({
          name: DAP_ROUTES.PROJECT,
          params: {
            projectId: String(this.projectId)
          }
        });
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  public created () {
    this.loadParameters();
  }

  public loadParameters () {
    const req = [
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/families`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/segments`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}/subProject/${this.dapId}`),
      httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/project/${this.projectId}`)
    ];

    Promise.all(req)
      .then((res: AxiosResponse[]) => {
        res[0].data.forEach((d: any) => {
          d.totalInfluence = 0;
          this.$set(this.productsDataSource, this.productsDataSource.length, d);
        });
        this.segmentsDataSource = res[1].data;

        _.forEach(res[2].data.subProjectLimits, (m: any) => {
          m.marketShareInfluence = this.getMarketShareInfluence(m.id as number, m.idMarketShareReference);
        });

        this.project = res[3].data;

        res[2].data.familySegmentInfluence = res[2].data.idSegmentGroup;
        this.subProject = Object.assign({}, this.subProject, res[2].data);
        this.subProject.initialHistoryPeriod = new Date(this.project.initialHistoryPeriod);
        this.subProject.finalHistoryPeriod = new Date(this.project.finalHistoryPeriod);
        this.subProject.initialDateProject = new Date(this.project.initialDateProject);
        this.subProject.idProject = this.project.id;
        this.currentTab = this.subProject.subProjectLimits[0].idMarketShareReference;
      })
      .catch((err: AxiosError) => console.log(err.message));
  }
}
